import React from 'react';
import { sprintf } from 'sprintf-js';

import { TileGridImageSize, TileGridTile } from 'api/cms';
import { Box } from 'components/Box';
import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { FilestackImage } from 'components/Image';
import { BodySmall, H4 } from 'components/Text';
import { colors } from 'theme';

import { TileGridBlockTileModal } from './Modal';
import { TileGridBlockTileContainer } from './TileGridBlockTile.styled';

type Props = {
  tile: TileGridTile;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onPrevious: (() => void) | undefined;
  onNext: (() => void) | undefined;
  imageSize: TileGridImageSize;
  blockIndex: number;
};

export function TileGridBlockTile({
  tile,
  isOpen,
  onOpen,
  onClose,
  onPrevious,
  onNext,
  imageSize,
  blockIndex,
}: Props) {
  const { heading, subHeading, thumbnail } = tile;
  const imageWidth = 238;

  return (
    <>
      <TileGridBlockTileContainer>
        <Box
          component={Button}
          onClick={onOpen}
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          flexDirection="column"
          p={['20px 0 !important', null, '32px 24px !important', null]}
          textAlign="center"
        >
          <Box
            width={imageWidth}
            mx="auto"
            mb={imageSize === 'SMALL' ? 24 : 36}
            $smallImage={imageSize === 'SMALL'}
          >
            <FilestackImage
              data={thumbnail}
              data-qa-id={`${imageSize === 'SMALL' ? 'small' : 'large'}-image`}
              alt={sprintf(getText('Image of %(heading)s'), {
                heading,
              })}
              width={imageWidth}
              height={imageSize === 'SMALL' ? 80 : imageWidth}
              fit={imageSize === 'LARGE' ? 'crop' : 'max'}
              quality={imageSize === 'SMALL' ? 'high' : undefined}
              round={imageSize === 'LARGE'}
              objectFit="cover"
            />
          </Box>

          <H4 mb={12} mt={0} color={colors.waterBlue}>
            {heading}
          </H4>

          <BodySmall>{subHeading}</BodySmall>
        </Box>
      </TileGridBlockTileContainer>

      {isOpen && (
        <TileGridBlockTileModal
          tile={tile}
          blockIndex={blockIndex}
          onClose={onClose}
          onPrevious={onPrevious}
          onNext={onNext}
        />
      )}
    </>
  );
}
